import { render, staticRenderFns } from "./blob_header.vue.js?vue&type=template&id=5070da26&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./blob_header.vue?vue&type=template&id=5070da26&vue3"
import script from "./blob_header.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./blob_header.vue?vue&type=script&lang=js&vue3"
export * from "./blob_header.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./blob_header.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports